<main class="gs">
  <section class="gs__card" role="status" aria-live="polite">
    @switch (phase) {
      @case ('starting') {
        <img class="gs__logo" src="/assets/images/favicon_mmonline.png" alt="" width="44" height="44">
        <h1 class="gs__title">{{strings['guest_start_title']}}</h1>
        <p class="gs__body">{{strings['guest_start_body']}}</p>
        <mat-spinner class="gs__spinner" diameter="30"></mat-spinner>
      }

      @case ('returning') {
        <div class="gs__badge"><mat-icon>history</mat-icon></div>
        <h1 class="gs__title">{{strings['guest_return_title']}}</h1>
        <p class="gs__body">{{strings['guest_return_body']}}</p>
        <div class="gs__actions">
          <button mat-flat-button color="primary" type="button" (click)="continueProject()">
            {{strings['guest_return_continue']}}
          </button>
          <button mat-stroked-button type="button" (click)="start()">
            {{strings['guest_return_new']}}
          </button>
        </div>
      }

      @case ('error') {
        <div class="gs__badge" [class.gs__badge--error]="errorIsFault"><mat-icon>{{errorIcon}}</mat-icon></div>
        <h1 class="gs__title">{{strings[errorTitleKey]}}</h1>
        <p class="gs__body">{{strings[errorBodyKey]}}</p>
        @if (canRetry) {
          <div class="gs__actions">
            <button mat-flat-button color="primary" type="button" (click)="start()">
              {{strings['try_again']}}
            </button>
          </div>
        }
      }
    }
  </section>

  <p class="gs__foot">Measure Map Online</p>
</main>
